import { PromotionBanners } from "@/components/homepage/PromotionBanners";
import { Tournaments } from "@/pages/Tournaments";
import { useDisplayLegalNotice, useFirstVisitStore } from "@/store";
import { useAuthStore } from "@/store/auth.store";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { LegalNoticeModal } from "./LegalNoticeModal";
import { NewUserModals } from "./NewUserModals";
import { shouldDisplayLegalNotice, shouldRedirectToTop } from "./utils";

export const HomePage = () => {
  const isFirstVisit = useFirstVisitStore((state) => state.isFirstVisit);
  const setIsFirstVisit = useFirstVisitStore((state) => state.setIsFirstVisit);
  const authState = useAuthStore((state) => state.authState);
  const isNewUser = useAuthStore((state) => state.isNewUser);
  const setIsNewUser = useAuthStore((state) => state.setIsNewUser);
  const user = useAuthStore((state) => state.user);
  const { isPreventedNotice, setShowLegalNotice, lastLegalNoticeDisplayTime, setLastLegalNoticeDisplayTime } =
    useDisplayLegalNotice();

  useEffect(() => {
    if (authState !== "authenticated") {
      setShowLegalNotice(false);
      return;
    }

    const now = Date.now();
    if (shouldDisplayLegalNotice(lastLegalNoticeDisplayTime, now)) {
      setShowLegalNotice(true);
      setLastLegalNoticeDisplayTime(now);
    }
  }, [authState, lastLegalNoticeDisplayTime, setShowLegalNotice, setLastLegalNoticeDisplayTime]);

  if (shouldRedirectToTop(isFirstVisit, authState)) {
    setIsFirstVisit(false);
    return <Navigate to="/top" />;
  }

  return (
    <div className="w-full">
      <PromotionBanners />
      <Tournaments />
      {isNewUser && <NewUserModals setIsNewUser={setIsNewUser} userFreePoints={user?.freePoints || "0"} />}
      {!isPreventedNotice && <LegalNoticeModal />}
    </div>
  );
};
